import { AfterViewInit, Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
import {
  WagtailPageContentElementInterface,
  WagtailPageContentRendererInterface
} from "@gea-waldviertler-website/gea-models";
import { WagtailContentRendererFactory } from '../../factory.content-renderer';

@Component({
    selector: 'wagtail-page-element-factory',
    templateUrl: './factory.component.html',
    standalone: false
})
export class FactoryComponent implements AfterViewInit {

  @ViewChild('content', { read: ViewContainerRef }) public content?: ViewContainerRef
  @Input() contentElements?: WagtailPageContentElementInterface<WagtailPageContentRendererInterface>[]

  ngAfterViewInit(): void {
    if (! this.contentElements) return

    for (const ce of this.contentElements) {
      WagtailContentRendererFactory.renderContentElement(this.content, ce)
    }
  }
}
